// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DashboardFormController from "./dashboard_form_controller"
application.register("dashboard-form", DashboardFormController)

import LoadingController from "./loading_controller"
application.register("loading", LoadingController)

import WebhookTestController from "./webhook_test_controller"
application.register("webhook-test", WebhookTestController)

import OauthPopupController from "./oauth_popup_controller"
application.register("oauth-popup", OauthPopupController)

import SlackOauthCallbackController from "./slack_oauth_callback_controller"
application.register("slack-oauth-callback", SlackOauthCallbackController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AsyncStyleController from "./async_style_controller"
application.register("async-style", AsyncStyleController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)
